module.exports = __webpack_public_path__ + "img/dispojob_label.f2f68f73.svg";